import styled from '@emotion/styled';
import { Divider, Grid } from '@material-ui/core';
import { Button, Magnetic, Thumbnail } from '@mitchell/react.component.ux';
import { THUMBNAIL_HEIGHT, THUMBNAIL_WIDTH } from '../constants';
export const StyledTwistyLabel = styled('div') `
	color: ${Magnetic.twistyBaseColor};
	font-weight: ${Magnetic.fontWeightSemibold};
	font-size: ${Magnetic.fontSize12};
	cursor: ${Magnetic.actionableCursor};
`;
const StyleDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: ${THUMBNAIL_HEIGHT};
	height: ${THUMBNAIL_WIDTH};
	outline: ${Magnetic.buttonFlatBorder};
	border-radius: 100%;
	border: ${Magnetic.buttonFlatBorder};
	cursor: ${Magnetic.buttonBaseCursor};
    margin-right: ${Magnetic.spacer08};
`;
export const StyledDivImageButton = styled('button') `
	${StyleDivBaseImage}
	background-color: ${(props) => props.backgroundColor};
	color: ${Magnetic.colorWhite};
    font-size: ${Magnetic.fontSize24}
`;
export const StyledDivImage = styled('img') `
	${StyleDivBaseImage}
`;
export const StyledPanelContainerGrid = styled(Grid) `
	div:has(#twisty-header) {
		width: 100%;
	}
	div#twisty-header {
		background-color: ${Magnetic.colorNeutral20};
		cursor: ${Magnetic.actionableCursor};
		border-radius: ${Magnetic.whiteLabelMobileSpeechBoxBorderRadius};
	}
`;
export const StyledPanelLabel = styled(Grid) `
	padding-left: ${Magnetic.spacer12};
	label {
		font-weight: ${Magnetic.fontWeightSemibold};
		color: ${Magnetic.colorBlack};
	}
`;
export const StyledAdditionalPanelLabel = styled(Grid) `
	text-align: center;
	label {
		font-weight: ${Magnetic.fontWeightSemibold};
		color: ${Magnetic.colorBlack};
	}
`;
export const StyledUploadButton = styled(Button) `
	opacity: ${({ isDisabled }) => isDisabled && 1};
	pointer-events: ${({ isDisabled }) => isDisabled && 'none'};
	height: ${THUMBNAIL_HEIGHT};
	width: ${THUMBNAIL_WIDTH};
	border-radius: ${Magnetic.whiteLabelMobileSpeechBoxBorderRadius};
	border: 2px dotted
		${({ isDisabled }) => (isDisabled ? Magnetic.colorGray : Magnetic.backgroundBrand05)};
	background-color: ${Magnetic.backgroundNeutral0};
	margin: ${Magnetic.spacer06} ${Magnetic.spacer08} ${Magnetic.spacer08} 0;
	padding: ${Magnetic.spacer04} ${Magnetic.spacer08};
	color: ${({ isDisabled }) => isDisabled && Magnetic.colorGray};
`;
export const StyledDivInlineView = styled('div') `
	margin: ${Magnetic.spacer06} ${Magnetic.spacer08} ${Magnetic.spacer08} 0;
	cursor: ${Magnetic.actionableCursor};
	border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.backgroundBrand05};
	border-radius: ${Magnetic.whiteLabelMobileSpeechBoxBorderRadius};
`;
export const StyledThumbnail = styled(Thumbnail) `
	border-radius: ${Magnetic.whiteLabelMobileSpeechBoxBorderRadius};
`;
export const StyleDamagePanelGridContainer = styled(Grid) `
	padding: ${Magnetic.spacer12} 0;
`;
export const StyleDamagePanelLabelGrid = styled(Grid) `
	padding: ${Magnetic.spacer04} 0;
`;
export const StyledEditIcon = styled('span', {
    shouldForwardProp: prop => prop !== 'isButtonDisabled'
})((props) => `
	font-size: ${Magnetic.fontSize12};
	margin: 0 ${Magnetic.spacer04};
	color: ${props.isButtonDisabled ? Magnetic.colorGray : Magnetic.colorBrand50};
	cursor: ${props.isButtonDisabled ? Magnetic.disabledCursor : Magnetic.actionableCursor};
`);
export const StyledDeleteIcon = styled('span') `
	color: ${Magnetic.colorBrand50};
	padding-right: ${Magnetic.spacer12};
`;
export const StyledClearPanelLabel = styled(Grid, {
    shouldForwardProp: prop => !['isPanelDisabled', 'isPanelMarginEnabled'].includes(prop)
})((props) => `
	margin-right: ${props.isPanelMarginEnabled && Magnetic.spacer12};

	label {
		color: ${props.isPanelDisabled ? Magnetic.colorGray : Magnetic.colorBrand50};
		margin: 0;
		cursor: ${props.isPanelDisabled ? Magnetic.disabledCursor : Magnetic.actionableCursor};
	}
`);
export const StyledBorderPanel = styled(Divider) `
	margin: 0 ${Magnetic.spacer04};
`;
export const StyledAddMoreLabel = styled('div', {
    shouldForwardProp: prop => prop !== 'isButtonDisabled'
})((props) => `
	color: ${props.isButtonDisabled ? Magnetic.colorGray : Magnetic.colorBrand50};
	font-weight: ${Magnetic.fontWeightNormal};
	font-size: ${Magnetic.fontSize12};
	cursor: ${props.isButtonDisabled ? Magnetic.disabledCursor : Magnetic.actionableCursor};
`);
export const StyledClearLabel = styled('div') `
	color: ${Magnetic.colorBrand50};
	font-weight: ${Magnetic.fontWeightNormal};
	font-size: ${Magnetic.fontSize12};
	margin: 0 ${Magnetic.spacer10} 0 ${Magnetic.spacer04};
`;
export const StyledAddMorePanelContainerGrid = styled(Grid) `
	padding: ${Magnetic.spacer12} 0px;
`;
export const StyledDamageGroupOptionWrapper = styled(Grid) `
	min-width: 240px;
	@media (max-width: ${Magnetic.layoutBreakpointMd}) {
		width: 100%;
		min-width: unset;
	}
`;
export const TemplateContainerGridWrapper = styled(Grid)(`
padding: ${Magnetic.spacer32};      
font-size: ${Magnetic.baseFontSize};
background-color: ${Magnetic.colorNeutral5};  
width: 100%; 
`);
export const ContentSectionGridWrapper = styled(Grid)(`
	font-weight: ${Magnetic.fontWeightSemibold};
	font-size: ${Magnetic.fontSize16};
	 &.confirmation-modal-description {
		font-weight: ${Magnetic.fontWeightSemibold};
		font-size: ${Magnetic.fontSize16};
		max-width: unset!important;
		flex-basis: unset!important;
		}
	`);
export const SpeechBoxSectionContainer = styled('div') `
	padding-top: ${Magnetic.spacer24};
`;
//# sourceMappingURL=PhotoCaptureDamagePanelComponent.style.js.map